export default {"src":"/_next/static/media/image3.584ac6ef.svg","height":134,"width":132,"blurWidth":0,"blurHeight":0};